import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: 0,
        margin: 0,
    },
    mainContainer: {
        margin: theme.spacing(5, 3),
    },
}));

export default useStyles;
